
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-3ae36815\",\"scoped\":false,\"hasInlineConfig\":true}!../../vue-loader/lib/selector?type=styles&index=0!./Collapse.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Collapse.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3ae36815\"}!../../vue-loader/lib/selector?type=template&index=0!./Collapse.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-collapse/src/Collapse.vue
// module id = 405
// module chunks = 40